import AddImidMeters from "components/AddImidDeviceAndMeters";
import AddMeters from "components/AddImidDeviceAndMeters/AddMeters";
import AddNewTenant from "components/AddNewTenant";
import AddTenantSummary from "components/AddTeanantSummary";
import CreateBuildingForm from "components/CreateBuildingForm/CreateBuildingForm";
import CreateCustomerForm from "components/CreateCustomerForm/CreateCustomerForm";
// import CustomerCreateBuilding from "components/CustomerCreateBuilding";
import { usePrompt } from "hooks/usePrompt";
import React, { useEffect, useState } from "react";

const CreateNewCustomerBuildings = () => {
  const customerInfo = localStorage.getItem("customerInfo");
  //   const [isFormDirty, setIsFormDirty] = useState(false);
  //   useEffect(() => {
  //     if (customerInfo) {
  //       setIsFormDirty(true);
  //     }
  //   }, []);

  //   // Call the hook to prompt the user
  //   usePrompt(
  //     "Are you sure you want to leave this page? Unsaved changes will be lost.",
  //     isFormDirty
  //   );

  const [activeTab, setActiveTab] = useState(1);

  const makeTabActive = (id) => {
    setActiveTab(id);
  };

  let content = null;

  switch (activeTab) {
    case 1:
      content = <CreateBuildingForm makeTabActive={makeTabActive} />;
      break;
    case 2:
      content = <AddImidMeters makeTabActive={makeTabActive} />;
      break;
    case 3:
      content = <AddMeters makeTabActive={makeTabActive} />;
      break;
    case 4:
      content = <AddNewTenant makeTabActive={makeTabActive} />;
      break;
    case 5:
      content = (
        <AddTenantSummary
          //   setIsFormDirty={setIsFormDirty}
          makeTabActive={makeTabActive}
        />
      );
      break;
    default:
      content = <CreateCustomerForm makeTabActive={makeTabActive} />;
  }

  return <div className="w-full ">{content}</div>;
};

export default CreateNewCustomerBuildings;
